import React from 'react';
import { Route, RouteProps, Switch } from 'react-router';

import { LayoutWrapper } from 'src/modules/app/components/Router/LayoutWrapper';

import { Sentry } from '../Providers/Telemetry/Sentry';

interface ProjectRouteProps extends RouteProps {
  dsn?: string;
  layoutWrapper?: ({ children }: { children: JSX.Element }) => JSX.Element;
}

const ProjectRoute = ({
  dsn,
  layoutWrapper,
  children,
  ...props
}: ProjectRouteProps) => (
  <Route {...props}>
    <Sentry dsn={dsn}>
      <LayoutWrapper wrapper={layoutWrapper}>
        <Switch>{children}</Switch>
      </LayoutWrapper>
    </Sentry>
  </Route>
);

export { ProjectRoute };
